import { type DownloadableFile, toBlob } from '@previo/core'
import { FileShareResultType } from '~/components/file-share-dialog/types/FileShareResultType'

export const toShareableFile = (file: DownloadableFile): File => {
  return new File([toBlob(file)], file.name, {
    type: file.mimeType ?? 'application/octet-stream',
  })
}

export const shareFile = async (file: File): Promise<FileShareResultType> => {
  if (!navigator.canShare?.({ files: [file] })) {
    return FileShareResultType.UNSUPPORTED
  }

  try {
    await navigator.share({ files: [file] })

    return FileShareResultType.SHARED
  } catch (e) {
    if (e instanceof DOMException && e.name === 'AbortError') {
      return FileShareResultType.CANCELLED
    }

    if (e instanceof DOMException && e.name === 'NotAllowedError') {
      return FileShareResultType.NEEDS_GESTURE
    }

    throw e
  }
}
